var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/shortcut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/shortcut",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8293 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H14.8293C14.4175 8.16519 13.3062 9 12 9C10.6938 9 9.58254 8.16519 9.17071 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H9.17071C9.58254 3.83481 10.6938 3 12 3C13.3062 3 14.4175 3.83481 14.8293 5ZM12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5ZM21 11H19.8293C19.4175 9.83481 18.3062 9 17 9C15.6938 9 14.5825 9.83481 14.1707 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H14.1707C14.5825 14.1652 15.6938 15 17 15C18.3062 15 19.4175 14.1652 19.8293 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11ZM16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12ZM9.82929 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H9.82929C9.41746 20.1652 8.30622 21 7 21C5.69378 21 4.58254 20.1652 4.17071 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H4.17071C4.58254 15.8348 5.69378 15 7 15C8.30622 15 9.41746 15.8348 9.82929 17ZM7 17C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19C7.55228 19 8 18.5523 8 18C8 17.4477 7.55228 17 7 17Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.36479bad.svg";
export { ForwardRef as ReactComponent };